import React, { Component } from 'react'
import decodeHtml from '../functions/decodeHtml'
import formatMenuItems from '../functions/formatMenuItems'



const FooterScrollTop = () => (
    <div className="footer-scroll-top">
        <a href="#">
            <span className="icon-wrapper">
                <span className="icon">
                    <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 9.3">
                        <polygon className="cls-1" points="25 1.26 24.19 0 12.5 7.52 0.81 0 0 1.26 12.5 9.3 25 1.26"/>
                    </svg>
                </span>
                <span className="screen-reader-text">Nach oben</span>
            </span>
        </a>
    </div>
)


const MenuLink = ({url, target, text, linkClass, textClass}) => {
    const textElem = <span className={textClass}>{decodeHtml(text)}</span>

    if('#' == url) {
        return <span className={linkClass}>{textElem}</span>
    } else if(target) {
        return <a className={linkClass} href={url} target={target}>{textElem}</a>
    } else {
        return <a className={linkClass} href={url}>{textElem}</a>
    }
}

const FooterMenuSubitem  = ({item}) => {
    const { is_active, title, url, target, classes } = item
    const activeClass = is_active ? ' item-active' : ''
    const menuClass = classes ? classes.join(' ') : ''

    if(classes && _.contains(classes, 'borlabs-cookie-open-dialog-preferences')) {
        return <li className={"sub-menu-item" + activeClass}>
            <span className={"sec-menu-item " + menuClass} data-borlabs-cookie-title={title}></span>
        </li>
    }
    
    if(classes && _.contains(classes, 'borlabs-cookie-preference')) {
        return <li className={"sub-menu-item" + activeClass}>
            <span className={"sec-menu-item " + menuClass}>{title}</span>
        </li>
    }

    return (
        <li className={"sub-menu-item" + activeClass}>
            <MenuLink 
                url={url}
                target={target}
                text={title}
                linkClass="sec-menu-item"
                textClass="menu-item-link footer-menu-level-sec"
            />
            {/* <a className="sub-menu-item text-light" href={url}><span className="menu-item-link">{decodeHtml(title)}</span></a> */}
        </li>
    )
}

const MenuItemToggle = ({id, isActive, onToggle}) => {
    const classActive = isActive ? ' is-active' : ''

    return (
        <button className={"menu-item-toggle cursor-pointer" + classActive} onClick={() => onToggle(id)}>
            <div className="icon-wrapper">
                <span className="icon"></span>
                <span className="screen-reader-text">Menü</span>
            </div>
        </button>
    )
}


const FooterMenuItem = ({item, activeMenuItem, classTypoFirstLevel, onItemToggle}) => {
    const { is_active, title, url, target, ID, classes  } = item
    const itemId = 'menu-item-' + ID
    const isActiveMenuItem = itemId === activeMenuItem 
    const hasChildren = item.hasOwnProperty('children')
    const activeClass = is_active ? ' item-active' : ''
    const activeMenuClass = isActiveMenuItem ? ' menu-item-active' : ''
    const childrenClass = hasChildren ? ' has-children' : ''
    const menuClass = classes ? classes.join(' ') : ''

    if(classes && _.contains(classes, 'borlabs-cookie-open-dialog-preferences')) {
        return <li className={"menu-item" + childrenClass + activeClass + activeMenuClass}>
            <span className={"first-menu-item " + menuClass} data-borlabs-cookie-title={title}></span>
        </li>
    }
    
    if(classes && _.contains(classes, 'borlabs-cookie-preference')) {
        return <li className={"menu-item" + childrenClass + activeClass + activeMenuClass}>
            <span className={"first-menu-item " + menuClass}>{title}</span>
        </li>
    }

    return (
        <li className={"menu-item" + childrenClass + activeClass + activeMenuClass}>
            <MenuLink 
                url={url}
                target={target}
                text={title}
                linkClass="first-menu-item"
                textClass={"menu-item-link " + classTypoFirstLevel}

            />

            {hasChildren && <MenuItemToggle
                id={itemId}
                isActive={isActiveMenuItem}
                onToggle={onItemToggle}
            />}

            {hasChildren && <ul className="sub-menu">
                {item.children.map((subItem, index) => <FooterMenuSubitem 
                    key={'footer-menu-subentry-' + index} 
                    item={subItem} 
                />)}
            </ul>}
        </li>
    )
}


const ExtraFooterMenu = ({extraBottomMenuData, activeMenuItem, onItemToggle}) => {

    if(!extraBottomMenuData) {
        return ''
    }

    const { items, order } = extraBottomMenuData

    if(!items || !order) {
        return ''
    }

    const menuItemsArray = []
    let largeMenu = false

    order.map(itemId => {
        menuItemsArray.push(items[itemId])
    })

    const formatedMenuItems = formatMenuItems(menuItemsArray)

    formatedMenuItems.map((menuItem) =>  {
        if(menuItem.hasOwnProperty('children')) {
            largeMenu = true
        }
    })

    const footerItems = formatedMenuItems.map((menuItem, index) =>  {
        const hasChildren = menuItem.hasOwnProperty('children')

        if(hasChildren) {
            largeMenu = true
        }

        return <FooterMenuItem 
            key={'footer-menu-entry-' + index} 
            item={menuItem} 
            activeMenuItem={activeMenuItem}
            onItemToggle={onItemToggle}
        />

    })

    const classMenuType = largeMenu ? 'large-menu' : 'small-menu'
    const classTypoFirstLevel = largeMenu ? 'footer-menu-level-first' : 'text-small-footer'

    return (
        <div className={"extra-footer-menu " + classMenuType}>
            <div className="grid-site-wrapper">
                <ul className="extra-footer-menu-list grid-extra-footer">
                    {formatedMenuItems.map((menuItem, index) => <FooterMenuItem 
                        key={'footer-menu-entry-' + index} 
                        item={menuItem} 
                        activeMenuItem={activeMenuItem}
                        classTypoFirstLevel={classTypoFirstLevel}
                        onItemToggle={onItemToggle}
                    />)}
                </ul>
                <FooterScrollTop />
            </div>
        </div>
    )
}


class ExtraFooterMenuContainer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            activeMenuItem: false
        }

        this.onItemToggle = this.onItemToggle.bind(this)
    }

    onItemToggle(itemId) {

        this.setState(prevState => ({
            activeMenuItem: prevState.activeMenuItem === itemId ? false : itemId
        }))
    }

    render() {
        const { activeMenuItem } = this.state
        const { extraBottomMenuData } = this.props

        return <ExtraFooterMenu
            extraBottomMenuData={extraBottomMenuData}
            activeMenuItem={activeMenuItem}
            onItemToggle={this.onItemToggle}
        />
    }

}

export default ExtraFooterMenuContainer